<template>
<!-- 输入框添加组件 -->
<!-- 组件使用方法 -->
<!-- 1.传入字符串:dns，ip为空格隔开 -->
<!-- 2.父组件传入GetAddInput方法返回参数为props -->
<!-- 3.每次修改输入框触发GetAddInput方法，props参数返回一个以空格隔开的字符串 -->
  <div>
    <div v-for="(item,index) in customizeDNS" :key="index">
          <el-input size="mini" class="Form-Input-Width" v-model="item.value"></el-input>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            class="Form-Buttom"
            @click="addcustomizeDNS"
            v-if="index==customizeDNS.length-1"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-minus"
            size="mini"
            class="Form-Buttom"
            @click="remcustomizeDNS(index)"
            v-else
          ></el-button>
        </div>
  </div>
</template>
<script>
export default {
  props:['dns'],
  data(){
    return{
      customizeDNS:[{}]
    }
  },
  methods:{
    //添加输入框
    addcustomizeDNS() {
      this.customizeDNS.push({ value: "" });
    },
    //删除输入框与内容
    remcustomizeDNS(index) {
      this.customizeDNS.splice(index, 1);
    },
    //字符串转换成可用的数组格式函数
    StringOrArray(str) {
    let Arr = []
    let ArrValue = str.split(' ')
    ArrValue.forEach((val, index) => {
        Arr.push({ value: val })
    })
    return Arr
    },
    //数组转换成可用的字符串格式上传
    ArrayOrString(Arr) {
    let Str = ''
    //循环传入的数组
    Arr.forEach((val, index) => {
      //如果数组下的值不为空,拼接成字符串上传
      if(val.value!==''){
        //判断是不是最后一个数组，如果是不用' '隔开字符串
        if(index!==Arr.length-1){
          Str += val.value+' '
        }else {
          Str += val.value
        }
      }
    })
    return Str
    }
  },
  mounted(){
    //如果dns不等于''或undefined
    if(this.dns){
      this.customizeDNS=this.StringOrArray(this.dns)
    }
  },
  watch:{
    customizeDNS:{
      handler(newvalue,oldValue){
        //判断是否为空
        if(newvalue!==''){
          let Value=this.ArrayOrString(this.customizeDNS)
          this.$emit('GetAddInput',Value)
        }
      },
      deep: true
    },
    dns:{
      handler(newValue,oldValue){
        if(oldValue===undefined&&newValue){
          this.customizeDNS=this.StringOrArray(this.dns)
        }
      }
    }
  }
}
</script>
<style scoped>
.Form-Input-Width {
  width: 5rem;
}
.Form-Buttom {
  margin-left: 0.2rem;
}
  .error-mess{
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
</style>
